module.exports = __webpack_public_path__ + "static/media/13n.8e18c44e.svg";